import { render, staticRenderFns } from "./NotificationsDrawer.vue?vue&type=template&id=30f18584&scoped=true"
import script from "./NotificationsDrawer.vue?vue&type=script&lang=ts"
export * from "./NotificationsDrawer.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsDrawer.vue?vue&type=style&index=0&id=30f18584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f18584",
  null
  
)

export default component.exports